/**
 * Single source of truth for QA / dev-tool gating.
 *
 * Ungates: DevAccountSwitcher (top-bar SA/OA/U switcher) and BugReportModal
 * (top-bar QA bug reporter). Active when running on localhost OR when the
 * deploy build sets VITE_ENABLE_DEV_TOOLS=true (develop env only — never prod).
 */
export const DEV_TOOLS_ENABLED =
  (typeof window !== 'undefined' && window.location.hostname === 'localhost') ||
  import.meta.env.VITE_ENABLE_DEV_TOOLS === 'true';
